module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-500-Classes-Active-a26ac1c9327776ce41c4a54d8f730ba9.png";